import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { DeceasedAction } from '@frontend/deceased/types';
import { WorkflowAction } from '@frontend/workflow/types';
import React from 'react';

const ID = 'deceased-action-select';

export interface DeceasedActionSelectProps extends Omit<SelectInputV2Props<string>, 'options'> {}

export const DeceasedActionSelect = (props: DeceasedActionSelectProps) => (
    <SelectInputV2
        {...props}
        id={ID + props.id}
        label={props.label || 'Deceased action'}
        options={[...DeceasedAction.ALL, ...WorkflowAction.ALL].map((action) => ({
            value: action.value,
            label: action.value,
            display: action.displayName
        }))}
    />
);

export default DeceasedActionSelect;
